import { Gauge } from 'lucide-react'
import CalibrationConsole from '../components/calibration/CalibrationConsole'

/** Thin adapter: AppShell's props in, the console out. */
export default function StationCalibrationPage(props) {
  const { currentUser, branches } = props
  const visible = currentUser.role === 'superadmin'
    ? branches
    : branches.filter((b) => b.organizationId === currentUser.organizationId)

  if (visible.length === 0) {
    return (
      <div className="rounded-xl border border-gray-200 bg-white p-8 text-center">
        <Gauge className="mx-auto mb-2 h-8 w-8 text-gray-300" />
        <p className="text-sm text-gray-500">No stations yet — add your first one to start setting up tanks and pumps.</p>
      </div>
    )
  }

  return <CalibrationConsole {...props} />
}
